import { Component, EventEmitter, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from '../../form-elements/components/svg-icon/svg-icon.component';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'qvs-no-internet-connection',
  templateUrl: './no-internet-connection.component.html',
  styleUrls: ['./no-internet-connection.component.scss'],
  standalone: true,
  imports: [IonicModule, SvgIconComponent, TranslatePipe]
})
export class NoInternetConnectionComponent {
  @Output() closeIndicator: EventEmitter<void> = new EventEmitter<void>();
}
